import { useQsFilters } from "@dash/filters";

import { ThreadSortField } from "@megaron/docs-contracts";
import { invoiceThreadFiltersSerializer } from "@megaron/megarax-uri";
import { SerializerValue, SortFilter } from "@megaron/serializers";

export type GroupFilter = "mine" | "all";

export type SortField = SortFilter<ThreadSortField>;

export type Filters = SerializerValue<typeof invoiceThreadFiltersSerializer>;

export const useThreadFilters = () => {
  const defaultFilters: Filters = {
    page: 0,
    searchText: "",
    sort: undefined,
    status: ["open"],
    signedBy: undefined,
    budgetUuid: undefined,
    isDigital: "any",
    isReceived: "any",
    isPosted: "any",
    participant: undefined,
    isRead: undefined,
    isOverdue: "any",
    isMine: "any",
    issuer: undefined,
    tags: undefined,
    groupFilter: "all",
  };

  const { filters, setFilters } = useQsFilters(invoiceThreadFiltersSerializer, defaultFilters);

  const setFilter =
    <Tkey extends keyof Filters>(key: Tkey) =>
    (value: Filters[Tkey]) => {
      if (key === "groupFilter") {
        if (value === "mine") {
          setFilters({
            ...defaultFilters,
            groupFilter: "mine",
            isMine: "true",
            sort: { field: "invitedAt", order: "DESC" },
            status: ["open"],
          });
          return;
        }

        setFilters({
          ...defaultFilters,
          groupFilter: "all",
          sort: { field: "createdAt", order: "DESC" },
          status: ["open"],
        });
        return;
      }

      setFilters({ ...filters, [key]: value });
    };

  return { filters, setFilter, defaultFilters, setFilters };
};
